// extracted by mini-css-extract-plugin
export default {"font-eudoxus":"style_font-eudoxus__k71fC","font-poppins":"style_font-poppins__uIypK","noMargin":"style_noMargin__3vVNT"};